/* C&B Studios theme — interactions */
(function () {
  'use strict';
  document.documentElement.classList.replace('no-js', 'js');

  var routes = window.cbRoutes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };
  var useDrawer = window.cbCartType === 'drawer';
  var drawer = function () { return document.querySelector('[data-cart-drawer]'); };
  var lastFocus = null;

  /* ---------- Header: scrolled state + mobile nav offset ---------- */
  var header = document.querySelector('[data-header]');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(rect.bottom, 0) + 'px');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  var mnav = document.querySelector('[data-mobile-nav]');
  if (mnav) {
    mnav.addEventListener('toggle', function () {
      onScroll();
      document.body.style.overflow = mnav.open ? 'hidden' : '';
    });
  }

  /* ---------- Cart drawer ---------- */
  function openDrawer() {
    var d = drawer();
    if (!d) { window.location.href = routes.cart; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = d.querySelector('.drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var current = document.getElementById('CartDrawerInner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var src = doc.querySelector('[data-cart-count-source]');
    if (src) updateCount(parseInt(src.textContent, 10) || 0);
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      if (n > 0) el.classList.add('is-bump');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle && useDrawer && drawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var lineBtn = e.target.closest('[data-line]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn, parseInt(lineBtn.dataset.line, 10), parseInt(lineBtn.dataset.lineQty, 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawer();
      if (d && d.classList.contains('is-open')) closeDrawer();
      if (mnav && mnav.open) mnav.open = false;
    }
  });

  function changeLine(btn, line, quantity) {
    var onCartPage = !!document.querySelector('[data-cart-page]');
    var wrap = btn.closest('.lines');
    if (wrap) wrap.classList.add('is-updating');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: onCartPage ? [] : ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (onCartPage) { window.location.reload(); return; }
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---------- Product forms (AJAX add to cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cb-form]');
    if (!form || !useDrawer || !drawer()) return;
    e.preventDefault();

    var btn = form.querySelector('[data-add-button]');
    var stickyBtn = document.querySelector('.sticky-buy .btn');
    var err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    [btn, stickyBtn].forEach(function (b) { if (b) b.classList.add('is-loading'); });

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (err) { err.textContent = data.description || data.message || 'Something went wrong.'; err.hidden = false; }
          return;
        }
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        [btn, stickyBtn].forEach(function (b) { if (b) b.classList.remove('is-loading'); });
      });
  });

  /* Quantity stepper */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.closest('[data-qty]').querySelector('input');
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
  });

  /* Variant select → price + availability */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var btn = form.querySelector('[data-add-button]');
      var available = opt.dataset.available === 'true';
      form.querySelector('[data-add-price]').textContent = opt.dataset.price;
      btn.disabled = !available;
      form.querySelector('[data-add-label]').textContent = available ? 'Add to cart' : 'Sold out';
      var url = new URL(window.location.href);
      if (document.body.classList.contains('template-product')) {
        url.searchParams.set('variant', sel.value);
        history.replaceState({}, '', url);
      }
    });
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    if (!track) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.galleryThumb, 10);
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  });

  /* ---------- Sticky buy bar ---------- */
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainForm = document.querySelector('.mp [data-add-button]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainForm);
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.section-head, .how__step, .pcard-game, .perfect__item, .iwt__media, .iwt__copy, .fp__media, .fp__info, .faq__item, .newsletter__panel, .rich__inner');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var t = en.target; t.classList.add('is-in'); io.unobserve(t);
          setTimeout(function () { t.style.transitionDelay = ''; }, 1300);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el, i) {
      if (el.closest('.shopify-section') && el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('reveal');
        var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.transitionDelay = Math.min(sibs, 5) * 70 + 'ms';
        io.observe(el);
      }
    });
  }

  /* Theme editor: keep drawer usable */
  document.addEventListener('shopify:section:load', function () { onScroll(); });
})();
